import { render, staticRenderFns } from "./gantt.vue?vue&type=template&id=5dcc04b6&scoped=true&"
import script from "./gantt.vue?vue&type=script&lang=js&"
export * from "./gantt.vue?vue&type=script&lang=js&"
import style0 from "./gantt.vue?vue&type=style&index=0&id=5dcc04b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcc04b6",
  null
  
)

export default component.exports